import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/providers/AuthProvider";
import { Loader2 } from "lucide-react";
import { normalizeAuthRedirectPath, storeAuthRedirect } from "@/utils/authRedirect";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-sl-bg flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-sl-accent" />
      </div>
    );
  }

  if (!user) {
    // Store full location (pathname + search + hash) for deep link support
    const from = normalizeAuthRedirectPath(location.pathname + location.search + location.hash) ?? '/dashboard';
    storeAuthRedirect(from, 'unauthenticated');
    return <Navigate to="/login" state={{ from, reason: 'unauthenticated' }} replace />;
  }

  return <>{children}</>;
};

